import { LoginPage as LoginPageShared } from '@practium/features/auth';
import { useAppNavigation } from '@practium/features/navigation';

export const LoginPageClient = () => {
	const { navigateToClientHome } = useAppNavigation();

	return <LoginPageShared onSuccess={navigateToClientHome} appContext="client" />;
};
